/**
 * WordPress dependencies.
 */
import {__} from '@wordpress/i18n';
import {registerFormatType, insert} from '@wordpress/rich-text';
import {RichTextToolbarButton} from '@wordpress/block-editor';
import {Modal} from '@wordpress/components';
import {useState} from '@wordpress/element';

/**
 * Internal dependencies.
 */
import IconsList from './icons-list';
import {AppContextProvider} from './context/app-context';

import './style.css';

const logoIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="currentColor" fill="none">
    <path fillRule="evenodd" clipRule="evenodd"
          d="M6.02484 8.5H17.9752C17.7012 5.7523 15.193 3.5 12 3.5C8.80696 3.5 6.29878 5.7523 6.02484 8.5ZM19.9827 8.5H20.5H22C22.5523 8.5 23 8.94772 23 9.5C23 10.0523 22.5523 10.5 22 10.5H21.3828L20.7505 15.5584C20.5751 16.962 20.4317 18.1095 20.2005 19.0108C19.9587 19.9537 19.5922 20.7522 18.8884 21.3736C18.1845 21.9949 17.3467 22.2595 16.3812 22.3825C15.4581 22.5001 14.3017 22.5 12.8872 22.5H11.1128C9.69832 22.5 8.54187 22.5001 7.61886 22.3825C6.65328 22.2595 5.8155 21.9949 5.11163 21.3736C4.40777 20.7522 4.04135 19.9537 3.79952 19.0108C3.56836 18.1095 3.42494 16.962 3.24953 15.5585L2.61722 10.5H2C1.44772 10.5 1 10.0523 1 9.5C1 8.94772 1.44772 8.5 2 8.5H3.50001H4.0173C4.29292 4.53184 7.82645 1.5 12 1.5C16.1736 1.5 19.7071 4.53184 19.9827 8.5Z"
          fill="currentColor"/>
  </svg>
);

const HugeiconsPicker = ({isActive, onChange, value}) => {
  const [isOpen, setIsOpen] = useState(false);
  const savedStyles = window.hugeiconStyles || [];

  const transformIconName = (name) => {
    const replacements = {
      "1st": "first",
      "2nd": "second",
      "3rd": "third",
      "3-d": "three-d",
      "3d": "three-d",
      "4-k": "four-k",
      "4k": "four-k"
    };

    return name.replace(/\b(1st|2nd|3rd|3-d|4-k|3d|4k)\b/g, match => replacements[match]);
  };

  const insertShortcode = (icon) => {
    // Transform the icon name
    const transformedName = transformIconName(icon.name);
    
    // Create the shortcode string with transformed name
    const shortcode = `[hugeicons icon="${transformedName}" variant="${icon.style.toLowerCase()}" style="${icon.type.toLowerCase()}"]`;
    
    // Use the insert method from rich-text package
    const newValue = insert(value, shortcode, value.start, value.end);
    
    // Apply the changes
    onChange(newValue);
    
    // Close the modal
    setIsOpen(false);
  };

  return (
    <>
      <RichTextToolbarButton
        icon={logoIcon}
        title={__('Hugeicons Icon', 'hugeicons')}
        onClick={() => setIsOpen(true)}
        isActive={isActive}
      />
      {isOpen && (
        <Modal
          title={__('Add a Hugeicons Icon', 'hugeicons')}
          onRequestClose={() => setIsOpen(false)}
          style={{ width: '90vw', maxWidth: '90%' }}
        >
          <AppContextProvider>
            <div className="hugeicons-modal-content">
              <IconsList
                onChange={insertShortcode}
                savedStyles={savedStyles}
              />
            </div>
          </AppContextProvider>
        </Modal>
      )}
    </>
  );
};

registerFormatType('hugeicons/icon', {
  title: __('Hugeicons Icon', 'hugeicons'),
  tagName: 'hgi',
  className: null,
  edit: HugeiconsPicker,
});